"use client";
import { AlertTriangle } from "lucide-react";
import { motion } from "framer-motion";

const Disclaimer = () => {
  return (
    <>
      <motion.div
        className="w-full mx-auto bg-gray-900 text-gray-200 p-6 border border-gray-700 rounded-lg shadow-lg"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="flex items-center gap-3 mb-4">
          <AlertTriangle className="text-yellow-400" size={28} />
          <h2 className="text-xl font-bold text-yellow-400">Disclaimer</h2>
        </div>
        <p className="text-gray-300 text-sm leading-relaxed">
          TotalSportek.cyou is an{" "}
          <span className="font-semibold">unofficial</span> sports schedule and
          information website. We do not host, own, or distribute any live
          streaming content. All trademarks, team names, and logos belong to
          their respective owners. This site is purely for informational
          purposes, and we encourage users to watch sports through official and
          legal sources.
        </p>
        <p className="mt-3 text-gray-400 text-xs">
          If you believe any content infringes your rights, please contact the
          respective official broadcasters.
        </p>
      </motion.div>
    </>
  );
};

export default Disclaimer;
